import { NAV_PATHS } from '@modules/common/constants';

export function replaceCodeAndErrorQueryParams() {
  const { pathname, search, hash } = window.location;

  const isSettingsRoute = pathname.includes(`${NAV_PATHS.SETTINGS}/`);
  const isExploreRoute = pathname.includes(`/${NAV_PATHS.EXPLORE}`);

  const hashedURLParams = new URLSearchParams(hash.slice(1));
  const queryParams = new URLSearchParams(search);

  if (isSettingsRoute || isExploreRoute) {
    const hasCodeQueryParam = queryParams.has('code');
    const hasAccessTokenParam = hashedURLParams.has('access_token');
    const hasErrorQueryParam = queryParams.has('error');

    if (hasCodeQueryParam) {
      window.history.replaceState(
        {},
        '',
        `${pathname}${search.replace('code=', 'integration_code=')}`,
      );
    }

    if (hasAccessTokenParam) {
      window.history.replaceState(
        {},
        '',
        `${pathname}${hash.replace('#access_token', '?integration_code')}`,
      );
    }

    if (hasErrorQueryParam) {
      window.history.replaceState(
        {},
        '',
        `${pathname}${search.replace('error=', 'integration_error=')}`,
      );
    }
  }

  const isLoginRoute = pathname.includes(NAV_PATHS.LOGIN);

  if (isLoginRoute) {
    const hasErrorQueryParam = queryParams.has('error');

    if (hasErrorQueryParam) {
      window.history.replaceState(
        {},
        '',
        `${pathname}${search.replace('error=', 'auth_error=')}`,
      );
    }
  }
}
